import { useEffect, useState, useCallback } from 'react';
import { memberId } from '@trello/session-cookie';
import ModelCache from 'app/scripts/db/model-cache.coffee';

interface BackboneEventEmitter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  on(type: string, callback: (...values: any[]) => void): BackboneModel;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  off(type: string, callback: (...values: any[]) => void): BackboneModel;
}

interface BackboneModel extends BackboneEventEmitter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(field: string): any;
}

const useColorBlind = () => {
  const [colorBlindState, setColorBlindState] = useState<boolean>(false);
  const prefsChangeEvent = 'change:prefs';

  const updateColorBlindState = useCallback(
    (model) => {
      const prefs = model.get('prefs');
      const colorBlind = !!(prefs && prefs.colorBlind);

      setColorBlindState(colorBlind);
    },
    [setColorBlindState],
  );

  useEffect(
    () => {
      let cancelled = false;
      let model: BackboneModel;

      // Wait for the member to be loaded, update based on current color-blind
      // pref and subscribe to changes
      ModelCache.waitFor('Member', memberId, (_: null, m: BackboneModel) => {
        if (m && !cancelled) {
          model = m;
          updateColorBlindState(model);
          model.on(prefsChangeEvent, updateColorBlindState);
        }
      });

      return () => {
        cancelled = true;

        if (model) {
          model.off(prefsChangeEvent, updateColorBlindState);
        }
      };
    },
    [updateColorBlindState],
  );

  return colorBlindState;
};

const useColorBlindDOMMutations = (isColorBlind: boolean) => {
  const colorBlindEnabledClass = 'body-color-blind-mode-enabled';

  useEffect(
    (): void => {
      const trelloRoot = document.getElementById('trello-root')!;

      if (!trelloRoot) {
        return;
      }

      if (isColorBlind) {
        trelloRoot.classList.add(colorBlindEnabledClass);
      } else {
        trelloRoot.classList.remove(colorBlindEnabledClass);
      }
    },
    [isColorBlind],
  );

  return null;
};

export const ColorBlindSupport = () => {
  const isColorBlind = useColorBlind();
  useColorBlindDOMMutations(isColorBlind);

  return null;
};
